module.exports = __webpack_public_path__ + "img/mercadopago.c7e273ad.png";